import _typeof from "@babel/runtime/helpers/typeof";
import store from '@utils/store';
import eventBus from '@utils/bus';
import util from '@utils/util';
import api from './api';
export default {
  REGTYPE: {
    fb: 101,
    tw: 103,
    google: 102,
    ins: 105,
    line: 110,
    email: 108,
    phone: 104
  },
  toBase64: window.Base64.toBase64,
  fromBase64: window.Base64.fromBase64,
  validate: function validate(value, type) {
    var Valitor = {
      email: {
        pattern: '^[0-9a-zA-Z]+([-_.]*[A-Za-z0-9]+)*[_]*@([A-Za-z0-9]+[-.])+[A-Za-z0-9]{2,5}$'
      },
      password: {
        pattern: '^.{6,20}$'
      },
      phone: {
        pattern: '^[0-9]*$'
      },
      name: {
        pattern: "^[A-Za-z0-9\u4E00-\u9FA5]+$"
      }
    };
    if (new RegExp(Valitor[type].pattern).test(value)) {
      return true;
    }
    return false;
  },
  getQueryData: function getQueryData(queryString) {
    queryString = queryString.replace(/^\?+/, '').replace(/&amp;/, '&');
    var querys = queryString.split('&');
    var i = querys.length;
    var urlParams = {};
    // eslint-disable-next-line no-plusplus
    while (i--) {
      var item = querys[i].split('=');
      if (item[0]) {
        var value = item[1] || '';
        try {
          value = decodeURIComponent(value);
        } catch (e) {
          value = unescape(value);
        }
        urlParams[decodeURIComponent(item[0])] = value;
      }
    }
    return urlParams;
  },
  loginAction: function loginAction(callback) {
    var _this = this;
    var queryData = this.getQueryData(window.location.search);
    if (queryData && queryData.code && !this.isLogined()) {
      api.code2Token(queryData.code).then(function (data) {
        if (data.access_token) {
          // accessToken, regType, keep = 0, callback is_new=true 新用户
          var regType = store.get('regType');
          var keep = queryData.is_new === 'true' ? '1' : '0';
          _this.userInfo(data.access_token, regType, keep, callback, '');
        }
      });
    } else {
      var uinfo = this.getUserInfo();
      if (uinfo && callback) {
        callback('success', uinfo);
      }
    }
  },
  logoutAction: function logoutAction(callback) {
    store.remove('userInfo');
    store.remove('deviceid');
    callback && callback();
  },
  isLogined: function isLogined() {
    var uinfo = store.get('userInfo');
    return !!uinfo;
  },
  updateUserInfo: function updateUserInfo(uinfo, callback) {
    store.set('userInfo', this.toBase64(JSON.stringify(uinfo)));
    if (uinfo.deviceid) {
      store.set('deviceid', uinfo.deviceid);
    }
    callback && callback(uinfo);
  },
  getUserInfo: function getUserInfo() {
    var value = store.get('userInfo');
    if (value) {
      var userInfo = JSON.parse(this.fromBase64(value));
      if (_typeof(userInfo) === 'object' && !userInfo.deviceid && store.get('deviceid')) {
        userInfo.deviceid = store.get('deviceid');
      }
      return userInfo || '';
    }
    return '';
  },
  thirdLogin: function thirdLogin(name) {
    var regType = this.REGTYPE[name];
    store.set('regType', regType);
  },
  register: function register(name, password, code, verifyCode, verifyCodeType, regType, keep, callback) {
    var _this2 = this;
    api.register(name, password, code, verifyCode, verifyCodeType).then(function (data) {
      if (data.ret === '1') {
        _this2.userInfo(data.access_token, regType, keep, callback, name);
      } else {
        callback && callback('fail', data);
      }
    }).catch(function (response) {
      // 这种情况 是 同盾 tongdun_black_box 没有 没有进行注册 需要用户再次尝试
      if (response === 'tongdun_fail') {
        callback && callback('tongdun_fail', response);
        return;
      }
      callback && callback('fail', response);
    });
  },
  channelSignin: function channelSignin(name, password, code, mPublicKey, regType, keep, callback) {
    var _this3 = this;
    api.channelSignin(name, password, code, mPublicKey).then(function (data) {
      // console.log('asdfasdfsadfsdf11', data);
      // need_captcha
      if (data && data.need_captcha === '1') {
        callback && callback('need_captcha', data);
      } else {
        _this3.userInfo(data.access_token, regType, keep, callback, name);
      }
    }).catch(function (response) {
      // console.log('asdfasdfsadfsdf22', response);
      callback && callback('fail', response);
      _this3.report('fail', keep, '', regType, name, JSON.stringify(response.data ? response.data : {}));
    });
  },
  userInfo: function userInfo(accessToken, regType) {
    var _this4 = this;
    var keep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var callback = arguments.length > 3 ? arguments[3] : undefined;
    var account = arguments.length > 4 ? arguments[4] : undefined;
    api.userInfo(accessToken, regType, keep).then(function (data) {
      if (window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf("".concat(data.status)) >= 0 || window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf(data.data && "".concat(data.data.status)) >= 0) {
        callback && callback('fail', data);
        _this4.report('fail', keep, '', regType, account, JSON.stringify(data));
      } else {
        var userData = data;
        userData.deviceid = api.androidid;
        if (userData.delete_account === '1') {
          // 0不弹框，1弹框
          eventBus.$emit('Restore-Login-Confirm', function (confirmVm) {
            var loading = util.loadingFunc();
            confirmVm.close();
            api.clearAccountStatus(data).then(function () {
              loading.hide();
              // 更新用户信息
              _this4.updateUserInfo(userData);
              store.set('regType', regType);
              callback && callback('success', userData);
              _this4.report('success', keep, userData.user.uid, regType, account, JSON.stringify(data));
            }).finally(function () {
              loading.hide();
            });
          });
          callback && callback('need_confirm');
          return;
        }
        _this4.updateUserInfo(userData);
        store.set('regType', regType);
        callback && callback('success', userData);
        _this4.report('success', keep, userData.user.uid, regType, account, JSON.stringify(data));
      }
    }).catch(function (response) {
      if (keep === 0 && response.data && response.data.status === '404') {
        // this.activeEmail(accessToken, regType, keep, callback, account);
        _this4.userInfo(accessToken, regType, 1, callback, account);
        return;
      }
      response.accessToken = accessToken;
      callback && callback('fail', response);
      _this4.report('fail', keep, '', regType, account, JSON.stringify(response.data ? response.data : {}));
    });
  },
  report: function report(state, type, uid, way, account, msg) {
    // 增加官网注册埋点上报，包括UID、时间戳、国家、大区、注册方式及账号（手机、邮箱、Twitter、Facebook、Google、line）
    // keep=0 是登录 =1 是注册
    var params = {
      state: '',
      // success fail
      type: '',
      // =0 是登录 =1 是注册
      uid: '',
      // uid
      timestamp: '',
      // 时间戳
      way: '',
      // 方式 phone
      account: '',
      // 账号
      returnInfo: ''
    };
    if (window.KEWLSensor) {
      window.KEWLSensor.register('kewlweb_logregpoint', params);
      window.KEWLSensor.track({
        state: state,
        type: type,
        uid: uid,
        way: way,
        account: account,
        timestamp: new Date().valueOf(),
        returnInfo: msg
      });
    }
  },
  selectLoginWay: function selectLoginWay(way) {
    var regType = '';
    switch (way.name) {
      case 'fb':
        regType = '101';
        break;
      case 'tw':
        regType = '103';
        break;
      case 'google':
        regType = '102';
        break;
      case 'ins':
        regType = '105';
        break;
      case 'line':
        regType = '110';
        break;
      case 'email':
        regType = '108';
        break;
      case 'phone':
        regType = '104';
        break;
      default:
        break;
    }
    localStorage.removeItem('keep'); // 注册框点击第三方注册需要传 keep是否强制注册，0不是，1是
    localStorage.setItem('regType', regType); // 登录标识
  }
};